module.exports = __webpack_public_path__ + "img/bf-logo.ce36fe01.svg";